import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import * as signalR from '@microsoft/signalr';
import { fetchCustomersTable } from '../api/customersApi';

const HUB_URL = `${import.meta.env.VITE_API_URL}/hub/liverefresh`;

export default function useCustomers(filter) {
    const queryClient = useQueryClient();

    const query = useQuery({
        queryKey: ['customers', filter],
        queryFn: () => fetchCustomersTable(filter),
        placeholderData: (prev) => prev,
    });

    useEffect(() => {
        const connection = new signalR.HubConnectionBuilder()
            .withUrl(HUB_URL, {
                // Clerk issues short-lived tokens; SignalR calls this factory
                // on connect and on reconnect, so we always hand it a fresh one.
                accessTokenFactory: () =>
                    window.Clerk.session.getToken({ template: 'marginpal-api' }),
            })
            .withAutomaticReconnect()
            .build();

        connection.on('UpdateCustomerTable', () => {
            queryClient.invalidateQueries({ queryKey: ['customers'] });
        });

        connection.start().catch(err => console.error('SignalR connection error:', err));

        return () => {
            connection.stop();
        };
    }, [queryClient]);

    return query;
}
